import axios from "axios";
import {
  IgrDataGrid,
  IgrDataGridModule,
  IgrNumericColumn,
  IgrTextColumn,
} from "igniteui-react-grids";
import React from "react";
import { getNoTime, getRank, getStartTime } from "../API";
import { entryList } from "../entryList";
import dayjs from "dayjs";
import Spinner from "react-bootstrap/Spinner";

export const makeTime = (num: number) => {
  var timeH = Math.floor((num % (24 * 60 * 60)) / (60 * 60));
  var timeM = Math.floor(((num % (24 * 60 * 60)) % (60 * 60)) / 60);
  var timeS = ((num % (24 * 60 * 60)) % (60 * 60)) % 60;
  var timeDMS = timeH
    ? timeH + "時間" + timeM + "分" + timeS + "秒"
    : timeM + "分" + timeS + "秒";
  return timeDMS;
};

IgrDataGridModule.register();

export function Rank() {
  const [data, setData] = React.useState<any[]>([]);
  const [loading, setLoading] = React.useState(false);
  React.useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const [resGetRank, resGetNoTime, resGetStartTime] = await Promise.all([
        axios.get(getRank),
        axios.get(getNoTime),
        axios.get(getStartTime),
      ]);
      if (!resGetRank.data.totalRank) {
        setLoading(false);
        return;
      }
      const startTime = dayjs(resGetStartTime.data.startTime);
      setData(
        resGetRank.data.totalRank.map((no: number, index: number) => {
          const cpLength = resGetNoTime.data[no].length;
          const time = dayjs(resGetNoTime.data[no][cpLength - 1].time);
          const second = time.diff(startTime, "seconds");
          const cp = resGetNoTime.data[no][cpLength - 1].cp;
          const targetNo = entryList.find((entry) => entry.No === no);
          return {
            rank: index + 1,
            no,
            time: makeTime(second),
            cp: cp.replace("CP_", ""),
            name: targetNo?.Name,
          };
        })
      );
      setLoading(false);
    };
    fetchData();
  }, []);

  if (loading) {
    return (
      <Spinner animation="border" role="status">
        <span className="visually-hidden">Loading...</span>
      </Spinner>
    );
  }

  return (
    <>
      <div
        style={{
          padding: "20px 50px 20px 50px",
          overflow: "scroll",
          WebkitOverflowScrolling: "touch",
          pointerEvents: "none",
        }}
      >
        <IgrDataGrid
          height="calc(100% + 1px)"
          width="100%"
          dataSource={data}
          autoGenerateColumns={false}
        >
          <IgrNumericColumn field="rank" width="90" headerText="順位" />
          <IgrNumericColumn field="no" width="90" headerText="No" />
          <IgrTextColumn field="name" headerText="名前" />
          <IgrTextColumn field="cp" headerText="最終通過CP" />
          <IgrTextColumn field="time" headerText="タイム" />
        </IgrDataGrid>
      </div>
    </>
  );
}
